<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>
      <section class="lp-bg" id="app">
        <img class="lp-title" :src="datas.product.img" />

        <!-- 查询输入框 -->
        <div class="lp-content lp-anti-fake" v-if="state === 100">
          <input maxlength="6" type="tel" v-model="vcode" @keyup.enter="CodeVerify" class="lp-anti-fake-input" placeholder="请在此输入6位数防伪码" />
          <a class="lp-anti-fake-button" @click="CodeVerify">查询</a>
        </div>

        <!-- 查询成功 -->
        <div class="lp-content" v-else-if="state === 200">
          <div class="lp-text">您购买的为{{datas.product.name}}品牌<i class="lp-content-focus">官方授权正品</i></div>
          <div class="lp-text">请放心使用</div>
          <div class="lp-text" v-if="datas.query_count > 1">当前为第<i class="lp-content-focus">{{datas.query_count}}</i>次查询</div>
          <div class="lp-text" v-if="datas.query_count > 1">首次查询时间<i class="lp-content-focus">{{ datas.query_first_time }}</i></div>
        </div>

        <!-- 查询失败 -->
        <div class="lp-content" v-else-if="state === 500">
          <div class="lp-text">对不起，您购买的产品为
          <i class="lp-content-focus">非官方渠道销售的产品</i></div>
          <div class="lp-text">请咨询购买渠道售后</div>
          <div class="lp-evalidation" @click="state = 100"><a class="lp-evalidation-botton">重新验证</a></div>
        </div>

        <div class="lp-logo"><img src="../../static/images/Normal13/logo.png"></div>
      </section>

      <!-- 提示框 -->
      <section id="MaskedBlock" v-if="hintTxt">
        <i class="Masked"></i>
        <div class="ToolTip">
          <ul>
            <li>{{ datas.business.name }}</li>
            <li class="MaskedMain" v-text="hintTxt"></li>
            <li class="confirm" v-on:click="CloseTip">确定</li>
          </ul>
        </div>
      </section>

      <!-- loading -->
		  <!-- <K-ModelLoading v-if="ModelLoading"></K-ModelLoading> -->

    </div>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
import ModelLoading from '@/components/ModelLoading.vue'
export default {
  name: 'Normal13',
  components: {
    'K-Loading': Loading,
    'K-Music': Music,
    'K-ModelLoading': ModelLoading
  },
  data () {
    return {
      state: 100,
      code:null,
      vcode: null,
      count:2,
      datas:null,
      hintTxt: null,
			ModelLoading: false,
      Loading:{
        type:1,
        txt:"数据请求中..."
      }
    }
  },
  created () {
    self = this;
    document.querySelector('body').setAttribute('style', 'background-color:#FFF');
    this.selfAdaption(); //字体rem自适应

    //判断是演示还是真实码标
    if(this.$route.query.type == "demo"){
      self.GetDemoDatas(this.$route.query.pid,this.$route.query.rid);  //获取演示模板信息
    }else{
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }

  },
  methods:{
    GetDemoDatas (pid,rid) {
      axios.get(self.GetServerUrl(1)+"template_product/"+pid+"/"+rid)
      .then(function (response){
        let datas = response.data.meta;
        let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

        if(datas.scan_count){
          datas.scan_count = datas.scan_count;
        }else{
          datas.scan_count = 1;
        }
        datas.scan_first_time = "2017-10-31 12:12";
        datas.scan_first_address = "广东省深圳市";
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);
        }else{
          if(defaultDatas.ref){
            datas.ref = JSON.parse(defaultDatas.ref);
          }
        }
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        if(datas.batch){
          datas.batch = JSON.parse(datas.batch);
          datas.batch.qc = JSON.parse(datas.batch.qc);
        }
        if(datas.music && datas.music_is_show == 1){
          try {
            datas.music = JSON.parse(datas.music);
          } catch (error) {
            console.error(error)
          }
        }
        if(datas.video){
          datas.video = JSON.parse(datas.video);
        }
        datas.activity_is_show = 1;

        //产品自定义属性
        if(datas.product.attribute){
          datas.product.attribute = JSON.parse(datas.product.attribute);
        }

        //企业自定义属性
        if(datas.business.customize_data){
          datas.business.customize_data = JSON.parse(datas.business.customize_data);
        }

        //默认信息
        if(!datas.process){
          datas.process = defaultDatas.process;
        }
        if(!datas.process_demo){
          datas.process_demo = defaultDatas.process_demo;
        }
        if(!datas.dealer){
          datas.dealer = defaultDatas.dealer;
        }
        
        self.datas = datas;
        // document.title = self.datas.business.name;  //设置页面标题
      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    GetDatas () {
      axios.get(self.GetServerUrl(1)+"query/"+self.code)
      .then(function (response){
        let datas = response.data.meta.product_template;
        datas.scan_count = response.data.meta.scan_count;  //扫码次数
        datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
        datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
        datas.query_count = response.data.meta.query_count;  //查询次数
        datas.query_first_time = response.data.meta.query_first_time;  //查询时间
        datas.query_first_address = response.data.meta.query_first_address;  //查询地点
        datas.verify =  response.data.meta.verify; //防伪码
        datas.plan_id =  response.data.meta.plan_id; //生码批次

        //自定义防伪查询语句
        if(datas.first_antifake_msg){
          self.msg = datas.first_antifake_msg;
        }

        //自定义属性
        if(response.data.meta.activation_a){
          datas.attribute = JSON.parse(response.data.meta.activation_a);
        }

        //焦点图
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        //自定义栏目
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);
        }
        //自定义菜单
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        //产品自定义属性
        if (datas.product.attribute) {
          datas.product.attribute = JSON.parse(datas.product.attribute);
        }
        //企业自定义属性
        if (datas.business.customize_data) {
          datas.business.customize_data = JSON.parse(datas.business.customize_data);
        }
        //批次信息
        if(datas.batch){
          if(datas.batch.qc){
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
        }
        datas.activity_is_show = 1;
        self.datas = datas;
        
        self.$nextTick(function(){
          new Swiper('.banner',{
            autoplay: {
              delay: 3000
            },
            autoHeight: true, //高度随内容变化
            loop: true, //可选选项，开启循环
          })

          //设置背景图片
          if(datas.focus && datas.focus.length > 0){
            self.setBgImg(datas.focus[0].img);
          }

        })

        // document.title = self.datas.business.name;  //设置页面标题
      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    CodeVerify() {
      if(self.vcode && self.vcode.length !== 6){
        self.hintTxt = "请输入正确的防伪码！";
        self.vcode = '';
        return;
      }
      self.ModelLoading = true; //loading
      axios.get(self.GetServerUrl(1) + "queryVerify/" + self.code + "/" + self.vcode)
        .then(function (response) {
          self.ModelLoading = false;
          var json = response.data;
          self.state = json.code;
          self.datas.query_count = json.meta.query_count;
          self.datas.query_first_time = json.meta.query_first_time;

          //设置背景图片
          if(self.datas.focus && self.datas.focus.length > 1){
            self.setBgImg(self.datas.focus[1].img);
          }
        }).catch(function (error) {
          self.ModelLoading = false;
          self.state = 500;
          self.vcode = '';

          //设置背景图片
          if(self.datas.focus && self.datas.focus.length > 0){
            self.setBgImg(self.datas.focus[0].img);
          }
        })
    },
    CloseTip() {
      self.hintTxt = null;
    },
    inited (viewer) {
      self.$viewer = viewer
    },
    PreviewImgs () {
      self.$viewer.show();
      self.$viewer.update();
    },
    ClickMenu (data) {
      if(data.type != 2){
        window.location.href = data.url;
      }else{
        this.$router.push({path: "/qr?qr="+data.qr});
      }
    },
    setBgImg(img){
      var bg = document.querySelector(".lp-bg");
      bg.style.backgroundImage = `url(${img})`;
    }
  }
}
</script>

<style scoped>
.lp-bg{
	position: fixed;
	top:0;right:0;
	left:0;bottom:0;
	background-repeat: no-repeat;
	background-size: cover;
	background-attachment: fixed;
	background-image: url(../../static/images/Normal13/bg-01.jpg);
}

.lp-title{
	width: 350rem;
	display: block;
	margin:0 auto;
	margin-top: 20vh;
}

.lp-content{
	margin-top: 10vh;
  padding: 0 10%;
}
.lp-text{
	color: #FFF;
	text-align: center;
	font-size:33rem;
	letter-spacing: 2rem;
	margin-bottom: 15rem;
}
.lp-error{
  font-size: 28rem;
}
.lp-content-focus{
	color: #F00;
}

.lp-logo{
	position: absolute;
	bottom: 10vh;
	left:0;right:0;
	width: 100%;
}
.lp-logo img{
	width: 70px;
	margin:0 auto;
	display: block;
}

.lp-anti-fake{
  padding:0 10%;
  overflow: hidden;
}
.lp-anti-fake-input{
  float: left;
  height: 80rem;
  padding: 0 20rem;
  display: block;
  color:#FFF;
  border-radius: 0;
  font-size:28rem;
  width: calc(100% - 160rem);
  border:2px solid #cbcbcb;
  background: rgba(0, 0, 0, .5);
}
.lp-anti-fake-button{
  border:0;
  float: left;
  width: 100rem;
  display: block;
  line-height: 80rem;
  text-align: center;
  font-size: 28rem;
  border:2px solid #cbcbcb;
  background-color: #cbcbcb;
}
.lp-evalidation-botton{
  width: 120rem;
  padding:18rem 30rem;
  border-radius: 10rem;
  display: table;
  margin:0 auto;
  margin-top: 3vh;
  font-size: 28rem;
  color: #222;
  background-color: rgba(203, 203, 203, .8);
}

.ToolTip ul li:last-child {
  background-image: linear-gradient(to bottom, #1260b5, #1c538f);
}
</style>



// WEBPACK FOOTER //
// src/view/Normal13.vue